import { Input } from "@/src/components/universalInput";
import { Reference } from "@/src/data/allTypes";
import { useState } from "react";

export function ExamForm({
  current,
  onChange,
}: {
  current?: Reference;
  onChange: (newValue: Reference) => void;
}) {
  let [data, setData] = useState(current || ({} as Reference));
  function setNewValue(newValue: Reference) {
    setData(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid c3 gap10">
      <Input
        name="Nom"
        value={data.name}
        type="text"
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({ ...data, name: newValue });
        }}
      />
      
    </div>
  );
}
